import {
    addVisitorRepresentatives,
    banVisitor,
    createContactProperty,
    createVisitorNote,
    deleteBannedVisitor,
    deleteContactProperty,
    deleteMultiVisitor,
    deleteTagVisitor,
    deleteVisitor,
    deleteVisitorNote,
    downloadVisitorList,
    getBannedVisitors,
    getCustomerDomains,
    getLastNote,
    getNotes,
    getOtherProfiles,
    getVisitor,
    getVisitorActivity,
    getVisitorList,
    getVisitorMediaByChatId,
    getVisitorNotes,
    getVisitors,
    mergeVisitors,
    removeVisitorRepresentatives,
    updateContactProperty,
    updatePreferredAgents,
    updatePreferredDepartment,
    updateTagVisitor,
    updateVisitorAttr,
    updateVisitorNote,
    getContactByField,
    deletePersonalData,
    downloadChatHistoryExcel,
    moveContactsToOtherChannel,
} from "../../api/visitor";
import { log2 } from "../../utils/log2";
import * as _ from "lodash";
import { sendSocketMessage } from "../../utils/socketStream";

const log = log2("visitor.vuex");
const visitor = {
    namespaced: true,
    state: {
        bannedVisitors: {
            total: 0,
            count: 0,
            data: [],
        },
        visitors: {
            total: 0,
            count: 0,
            data: [],
        },
        liveVisitors: [], //bunlar site ziyaretcisi
        customerDomains: [],
        liveVisitorCount: 0,
        selectedVisitor: {},
        visitorMedia: [],
    },
    mutations: {
        SET_LIVE_VISITOR_COUNT: (state) => {
            state.liveVisitorCount = state.liveVisitors.length;
        },
        SET_VISITORS: (state, payload) => {
            if (payload.infinityScroll === true) {
                state.visitors.data = payload.data;
                state.visitors.total = payload.total;
                state.visitors.count = payload.count;
                state.visitors.pageCount = payload.pageCount;
                state.visitors.pageSize = payload.pageSize;
            } else {
                state.visitors = payload;
            }
        },
        SET_SELECTED_VISITOR: (state, payload) => {
            state.selectedVisitor = payload;
        },
        UPDATE_VISITOR_TAGS: (state, { visitorId, tags }) => {
            const findIndex = _.findIndex(state.visitors.data, (q) => q._id === visitorId); //O(n) düzelt
            if (findIndex > 0) {
                state.visitors.data[findIndex].tags = tags;
            }
        },
        MULTI_VISITOR_UPDATE: (state, visitors) => {
            state.liveVisitors = _.uniqBy(visitors, (q) => q._id);
        },
        SET_MULTI_VISITOR_AS_PARTED: (state, { visitors, partNumber }) => {
            if (partNumber === 1) {
                state.liveVisitors = visitors;
            } else {
                state.liveVisitors = _.concat(state.liveVisitors, visitors);
            }
        },
        UPDATE_VISITOR: (state, visitor) => {
            const findIndex = _.findIndex(state.liveVisitors, (q) => q._id === visitor._id); //O(n) düzelt
            if (findIndex > 0) {
                state.liveVisitors[findIndex] = visitor;
            } else {
                state.liveVisitors = _.uniqBy([...state.liveVisitors, visitor], (q) => q._id); //O(n) düzelt
            }
        },
        UPDATE_VISITOR_CUSTOM_FIELDS: (state, { visitorId, updatingFields }) => {
            const findIndex = _.findIndex(state.liveVisitors, (q) => q._id === visitorId); //O(n) düzelt
            if (findIndex > 0) {
                state.liveVisitors[findIndex] = {
                    ...state.liveVisitors[findIndex],
                    ...updatingFields,
                };
            }
        },
        BATCH_ADD_LIVE_VISITOR: (state, connectedIds) => {
            state.liveVisitors = _.uniq([...state.liveVisitors, ...connectedIds]);
        },
        SET_VISITOR_OFFLINE: (state, visitorId) => {
            state.liveVisitors = _.filter(state.liveVisitors, (q) => q._id !== visitorId);
        },
        MULTI_VISITOR_OFFLINE: (state, ids) => {
            const idsMap = ids.reduce((acc, cur) => {
                acc[cur] = true;
                return acc;
            }, {});
            state.liveVisitors = state.liveVisitors.filter((id) => !idsMap[id]);
        },
        SET_BANNED_VISITORS: (state, payload) => {
            state.bannedVisitors = payload;
        },
        DELETE_BANNED_VISITOR: (state, id) => {
            state.bannedVisitors.data = state.bannedVisitors.data.filter((v) => v._id !== id); //O(n) düzelt
        },
        SET_CUSTOMER_DOMAINS: (state, data) => {
            state.customerDomains = data;
        },
        ADD_CUSTOMER_DOMAIN: (state, domain) => {
            state.customerDomains = _.uniq([...state.customerDomains, domain]);
        },
        SET_VISITOR_MEDIA: (state, media) => {
            state.visitorMedia = media;
        },
    },
    actions: {
        getVisitors({ commit, rootState }, payload) {
            return getVisitors(
                payload.limit,
                payload.skipCount,
                payload.startDate,
                payload.endDate,
                payload.query,
                payload.userId,
                payload.point,
                payload.description,
                payload.homeSite,
                payload.videoCall,
                payload.lostChats,
                payload.subjectId || rootState.subject.selectedSubject,
                payload.refs,
                payload.closedByAgent,
                payload.visitorId,
                payload.tags,
                payload.downloadAsFile,
                payload.channelIds,
                payload.destroyers,
                payload.starters
            ).then((response) => {
                if (!payload.downloadAsFile) {
                    response.data.infinityScroll = payload.infinityScroll;
                    commit("SET_VISITORS", response.data);
                }
                return response.data;
            });
        },
        getVisitorList({ commit }, payload) {
            return getVisitorList(payload).then((response) => {
                return response;
            });
        },
        downloadVisitorList({ commit }, payload) {
            return downloadVisitorList(payload);
        },
        deleteVisitor({ commit }, payload) {
            return deleteVisitor(payload).then((response) => {
                return response;
            });
        },
        deleteMultiVisitor({ commit }, ids) {
            return deleteMultiVisitor(ids).then((response) => {
                return response.data;
            });
        },
        deleteTagVisitor({ commit }, payload) {
            return deleteTagVisitor(payload).then((response) => {
                return response;
            });
        },
        updateTagVisitor({ commit, rootState }, payload) {
            return updateTagVisitor(payload).then((response) => {
                commit("UPDATE_VISITOR_TAGS", response.data);
                sendSocketMessage("visitor profile-updated", {
                    siteId: rootState.site.site._id,
                    visitorId: payload.visitorId,
                    updatingFields: {
                        tags: payload.tagIds,
                    },
                });
                return response;
            });
        },
        getVisitor({ commit }, payload) {
            return getVisitor(payload).then((response) => {
                commit("SET_SELECTED_VISITOR", response.data);
                return response;
            });
        },
        getCustomerDomains({ commit, state }) {
            return getCustomerDomains().then((response) => {
                commit("SET_CUSTOMER_DOMAINS", response.data);
            });
        },
        getCustomerDomainsIfNeed({ commit, state }) {
            if (state.customerDomains.length === 0) {
                return getCustomerDomains().then((response) => {
                    commit("SET_CUSTOMER_DOMAINS", response.data);
                    return response.data;
                });
            }
            return Promise.resolve(state.customerDomains);
        },
        getBannedvisitors({ commit }, payload) {
            const { page, perPage } = payload;
            return getBannedVisitors(perPage, page).then((response) => {
                commit("SET_BANNED_VISITORS", response.data);
            });
        },
        banVisitor({ commit, state }, id) {
            return banVisitor(id).then((response) => {
                const visitor = state.visitors.data.find((v) => v._id == id);
                if (visitor) {
                    visitor.isBlocked = true;
                    const isBannedVisitor = this.bannedVisitors.data.find((v) => v._id == id);
                    if (!isBannedVisitor) commit("SET_BANNED_VISITORS", [...this.bannedVisitors.data, visitor]);
                }
                return Promise.resolve(response);
            });
        },
        unbanVisitor({ commit }, id) {
            return deleteBannedVisitor(id).then((response) => {
                commit("DELETE_BANNED_VISITOR", id);
                return Promise.resolve(response);
            });
        },
        multiVisitorUpdate({ commit }, visitors) {
            commit("MULTI_VISITOR_UPDATE", visitors);
        },
        updateVisitor({ commit }, visitor) {
            commit("UPDATE_VISITOR", visitor);
        },
        batchAddLiveVisitor({ commit }, connectedIds) {
            commit("BATCH_ADD_LIVE_VISITOR", connectedIds);
        },
        setVisitorOffline({ commit }, visitorId) {
            commit("SET_VISITOR_OFFLINE", visitorId);
        },
        setMultiVisitorOffline({ commit }, ids) {
            commit("MULTI_VISITOR_OFFLINE", ids);
        },
        reportLiveVisitorCount({ rootState, commit, getters, state }, liveVisitorCount) {
            if (rootState.auth.user && rootState.site.site && rootState.socketStatus.socket_connected) {
                sendSocketMessage("user get-live-visitor-count", {
                    userId: rootState.auth.user._id,
                    liveVisitorCount,
                    siteId: rootState.site.site._id,
                });
            }
        },
        addCustomerDomain({ commit }, domain) {
            commit("ADD_CUSTOMER_DOMAIN", domain);
        },
        setMultiVisitorAsParted({ commit }, payload) {
            commit("SET_MULTI_VISITOR_AS_PARTED", payload);
        },
        setLiveVisitorCount({ commit }) {
            commit("SET_LIVE_VISITOR_COUNT");
        },
        addVisitorRepresentatives({ commit }, payload) {
            log("addVisitorRepresentatives", payload);
            return addVisitorRepresentatives(payload.siteId, payload.visitorId, payload.userId).then((res) => {
                commit("UPDATE_VISITOR", res.data);
            });
        },
        removeVisitorRepresentatives({ commit }, payload) {
            return removeVisitorRepresentatives(payload.siteId, payload.visitorId, payload.userId).then(() => {
                commit("UPDATE_VISITOR", res.data);
            });
        },
        updatePreferredAgents({ commit }, payload) {
            log("updatePreferredAgents", payload);
            return updatePreferredAgents(payload.visitorId, payload.userIds).then((res) => {
                // commit("UPDATE_VISITOR_CUSTOM_FIELDS", {
                //     preferredAgents: payload.userIds,
                // });
                return res.data;
            });
        },
        updatePreferredDepartment({ commit }, { visitorId, departmentId }) {
            return updatePreferredDepartment(visitorId, departmentId).then((res) => {
                // commit("UPDATE_VISITOR_CUSTOM_FIELDS", {
                //     preferredAgents: payload.userIds,
                // });
                return res.data;
            });
        },
        createContactProperty({ rootState, commit, state }, { visitorId, payload }) {
            const { contactProperties, ...rest } = payload;
            return createContactProperty(visitorId, rest).then((res) => {
                sendSocketMessage("visitor profile-updated", {
                    siteId: rootState.site.site._id,
                    visitorId,
                    updatingFields: {
                        contactProperties: [...contactProperties, res.data],
                    },
                });

                const visitor = state.visitors.data.find((v) => v._id == visitorId);
                if (visitor) {
                    visitor.contactProperties = [...visitor.contactProperties, res.data];
                    commit("UPDATE_VISITOR", visitor);
                }
                return res.data;
            });
        },
        deleteContactProperty({ rootState, commit, state }, { visitorId, contactPropertyId }) {
            return deleteContactProperty(visitorId, contactPropertyId).then((res) => {
                const visitor = state.visitors.data.find((v) => v._id == visitorId);
                if (visitor) {
                    visitor.contactProperties = visitor.contactProperties.filter((c) => c._id == contactPropertyId);
                    log.info("deleteContactProperty", visitor.contactProperties);
                    sendSocketMessage("visitor profile-updated", {
                        siteId: rootState.site.site._id,
                        visitorId,
                        updatingFields: {
                            contactProperties: visitor.contactProperties,
                        },
                    });
                    commit("UPDATE_VISITOR", visitor);
                }
            });
        },
        updateContactProperty({ rootState, commit, state }, { visitor, contactPropertyId, updatePayload }) {
            return updateContactProperty(visitor._id, contactPropertyId, updatePayload).then((res) => {
                const updatingVisitor = state.visitors.data.find((v) => v._id == visitor._id) || visitor;
                const fProperty = updatingVisitor.contactProperties.find((c) => c._id == res.data._id);
                if (!fProperty) updatingVisitor.contactProperties = [...updatingVisitor.contactProperties, res.data];
                updatingVisitor.contactProperties = updatingVisitor.contactProperties.map((c) => {
                    if (c._id == res.data._id) c = res.data;
                    return c;
                });
                commit("UPDATE_VISITOR", updatingVisitor);
                sendSocketMessage("visitor profile-updated", {
                    siteId: rootState.site.site._id,
                    visitorId: visitor._id,
                    updatingFields: {
                        contactProperties: updatingVisitor.contactProperties,
                    },
                });
                return updatingVisitor;
            });
        },
        updateVisitorAttr({ rootState, commit }, { publishSocket = true, visitorId, payload }) {
            return updateVisitorAttr(visitorId, payload).then((res) => {
                commit("UPDATE_VISITOR", res.data);
                if (publishSocket) {
                    sendSocketMessage("visitor profile-updated", {
                        siteId: rootState.site.site._id,
                        visitorId,
                        updatingFields: payload,
                    });
                }
                return res.data;
            });
        },
        getLastNote({ commit }, visitorId) {
            return getLastNote(visitorId).then((res) => res.data);
        },
        getNotes({ commit }, visitorId) {
            return getNotes(visitorId).then((res) => res.data);
        },
        getVisitorActivity({ commit }, visitorId) {
            return getVisitorActivity(visitorId).then((res) => res.data);
        },
        getOtherProfiles({ commit }, visitorId) {
            return getOtherProfiles(visitorId).then((res) => res.data);
        },
        mergeVisitors({ commit }, payload) {
            return mergeVisitors(payload).then((res) => res.data);
        },
        getVisitorNotes({ commit }, visitorId) {
            // v2 multiple notes
            return getVisitorNotes(visitorId);
        },
        createVisitorNote({ commit }, { visitorId, payload }) {
            // v2 multiple create note
            return createVisitorNote(visitorId, payload);
        },
        updateVisitorNote({ commit }, { visitorId, noteId, payload }) {
            // v2 multiple create note
            return updateVisitorNote(visitorId, noteId, payload);
        },
        deleteVisitorNote({ commit }, noteId) {
            return deleteVisitorNote(noteId);
        },
        async fetchVisitorMedia({ commit }, { visitorId }) {
            const media = await getVisitorMediaByChatId(visitorId);
            commit("SET_VISITOR_MEDIA", media);
            return media;
        },
        async getContactByField({}, { field, query }) {
            return getContactByField(field, query);
        },
        downloadChatHistoryExcel({}, params) {
            return downloadChatHistoryExcel(params);
        },
        async moveContactsToOtherChannel({ commit }, { sourceChannelId, targetChannelId }) {
            return await moveContactsToOtherChannel(sourceChannelId, targetChannelId);
        },
    },
};

export default visitor;
